// frontend/src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import {
  getStorage,
  ref as storageRef,
  listAll,
  getDownloadURL,
} from "firebase/storage";
import {
  getFirestore,
  collection,
  doc,
  getDoc,
  getDocs,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBGpLo-JlCnjT3roUywSx-i-_WBAU1ZPHI",
  authDomain: "flowmax-mezzomo.firebaseapp.com",
  projectId: "flowmax-mezzomo",
  storageBucket: "flowmax-mezzomo.firebasestorage.app",
  messagingSenderId: "422508367659",
  appId: "1:422508367659:web:80a6c20520acca076fff6e",
  measurementId: "G-M6KE5EPFS0",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export let analytics = null;
if (typeof window !== "undefined" && firebaseConfig.measurementId) {
  analytics = getAnalytics(app);
}
export { logEvent };
export const storage = getStorage(app);
export const db = getFirestore(app);
export {
  storageRef,
  listAll,
  getDownloadURL,
  collection,
  doc,
  getDoc,
  getDocs,
}; // Exportação direta

export const functions = getFunctions(app, "europe-west3");

export default app;
